module.exports = __webpack_public_path__ + "img/university_icon.6520a140.svg";